<template>
  <div :class="{'show' : show}" class="close-chat-modal" :style="{ 'background-color': $store.state.campaign.color, 'color': invertColor(this.$store.state.campaign.color) }">
    <div>{{messageDialogue}}</div>
    <v-btn text @click.native="confirmClosing" :style="{'color': invertColor($store.state.campaign.color)}">{{$t('yes')}}</v-btn>
    <v-btn text @click.native="cancelClosing" :style="{'color': invertColor($store.state.campaign.color)}">{{$t('no')}}</v-btn>
  </div>
</template>

<script>
import { invertColor } from "@/assets/utils"
export default {
  props: {show : Boolean, 
          messageDialogue: String
          },
  name: 'closing-dialog',
  data() {
    return {
      dialog: false
    };
  },

  methods: {
    invertColor,

    cancelClosing() {
      this.$emit("cancelClosingEv", false);
    },

    confirmClosing() {
      this.$emit("confirmClosingEv", true);
    },

  }
};
</script>

<style>

.close-chat-modal {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 75px;
    opacity:0;
    padding-top: 10px;
    border-top: 1px solid #00000054;
    box-shadow: 0px 4px 5px -3px #00000066;
    text-align: center;
    transition:all .3s ease-out;
}

.close-chat-modal::after {
  content: "";
  background: linear-gradient(129deg,rgba(35, 146, 236, 0),rgba(0, 0, 0, 0.35));
  background-blend-mode: overlay;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 0;
}

.close-chat-modal.show {
  top: 67px;
  opacity:1;
  z-index: 999999;
}

.close-chat-modal button {
  z-index:2;
  opacity:.8
}
</style>
